export const MonitoringErrorMessages = {
  RUM_DISABLED_VIA_FLAG:
    "Datadog RUM disabled via VITE_DD_ENABLED flag. Set VITE_DD_ENABLED=true to enable.",

  RUM_CREDENTIALS_NOT_CONFIGURED:
    "Datadog RUM credentials not configured - skipping initialization. Set VITE_DD_APPLICATION_ID and VITE_DD_CLIENT_TOKEN to enable.",

  RUM_ALREADY_INITIALIZED: "Datadog RUM already initialized, skipping...",

  RUM_INIT_SUCCESS: (service: string, environment: string): string =>
    `Datadog RUM initialized for ${service} (${environment})`,

  RUM_INIT_CRITICAL_FAILURE: (service: string): string =>
    `CRITICAL: Failed to initialize Datadog RUM for ${service}. ` +
    "User tracking, error monitoring, and performance analytics are disabled. " +
    "Application will continue without monitoring.",

  RUM_INIT_FAILED: (details: string): string =>
    `Datadog RUM initialization failed. Fix configuration before deploying. ${details}`,

  RUM_SET_USER_FAILED: (userId: string, details: string): string =>
    `Failed to set RUM user (userId: ${userId}). User tracking will not work for this session. ${details}`,

  RUM_CLEAR_USER_FAILED: (details: string): string =>
    `Failed to clear RUM user. User may remain associated with subsequent sessions. ${details}`,

  RUM_ADD_ACTION_FAILED: (actionName: string, details: string): string =>
    `Failed to add RUM action "${actionName}". This user interaction will not be tracked. ${details}`,

  RUM_METHOD_CALLED_UNINITIALIZED: (
    methodName: string,
    reason: string,
  ): string =>
    `Datadog RUM ${methodName}() called but ${reason}. User tracking and analytics are disabled.`,
} as const;
